import React, { memo } from 'react';
import { Button } from 'app/shared/components';
import { GoNextPageService } from 'app/modules/survey';
import { useSurveyConfig } from 'app/core/survey-config';
import { userAgent } from 'config/system';
import * as styles from './styles';

function Nextpage() {
  const { wording } = useSurveyConfig();
  const goNextPage = GoNextPageService.useGoPage();
  const [disabled] = GoNextPageService.useGoPageStatus();

  const onTouchEnd = () => {
    goNextPage();
  };

  const onClick = () => {
    goNextPage();
  };

  return (
    <div className={styles.nextPageContainer}>
      <Button
        color="primary"
        disabled={disabled}
        {...{
          ...(userAgent.isIOS && { onTouchEnd }),
          ...(!userAgent.isIOS && { onClick }),
        }}
      >
        {wording.common.action.next_page}
      </Button>
    </div>
  );
}

export default memo(Nextpage);
